module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Broom-287275d3564d385bbc832954e86d83d5.svg";